import React from 'react'

import Modal from 'antd-v3/es/modal'

import Icon from 'src/components/Icon'

export const showConfirmModal = (props) =>
  Modal.confirm({
    width: 316,
    title: 'Confirm action',
    icon: <Icon name="question" />,
    okButtonProps: { type: 'danger' },
    okText: 'Yes',
    ...props
  })

export const showConfirmDeleteModal = (props) =>
  showConfirmModal({
    width: 316,
    icon: <Icon name="trash" />,
    okButtonProps: { type: 'danger' },
    okText: 'Yes, delete',
    ...props
  })

export const showModalCancelModal = (props) =>
  showConfirmModal({
    width: 350,
    content: (
      <div className="display-flex column">
        <span>Closing this window will discard all unsaved changes.</span>
        <span>Are you sure you want to proceed?</span>
      </div>
    ),
    zIndex: 2000,
    icon: <Icon name="exclamation-triangle" />,
    okText: 'Ok',
    ...props
  })

export const showErrorModal = (props) =>
  Modal.error({
    width: 316,
    title: 'Error',
    icon: <Icon name="times-circle" />,
    ...props
  })

export const showInfoModal = (props) =>
  Modal.info({
    width: 316,
    icon: <Icon name="info-circle" />,
    ...props
  })

export const showSuccessModal = (props) =>
  Modal.success({
    width: 316,
    title: 'Success',
    icon: <Icon name="check-circle" />,
    ...props
  })

export const showWarningModal = (props) =>
  Modal.warning({
    width: 316,
    title: 'Warning',
    icon: <Icon name="exclamation-triangle" />,
    ...props
  })
